import { InphiniteThemeColors, Label, useDeviceSize } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { useVariables } from '../../hooks';
import { useData } from '../../providers';
import { StatusTypeList, StatusOperations } from '../../states';
import { CardResults, CardResultsContent } from '../cards';
import { Banner } from './Banner';
import { onboardingIconNew } from './Results';
import { StatusTypeProps } from './StatusIcon';

export const ResultsHeader = () => {
  const { t } = useTranslation();
  const { isMobile } = useDeviceSize();
  const { operationFinishedState } = useData();
  const { isCanada } = useVariables();

  const getLabelColor = (status: StatusTypeProps | undefined) => {
    let color = 'grey700';
    switch (status) {
      case StatusOperations.SUCCEEDED:
        color = 'success400';
        break;
      case StatusOperations.DENIED:
        color = 'error400';
        break;
      case StatusOperations.CONNECTION_ERROR:
      case StatusOperations.CHECK_PLATFORM:
        color = 'warning400';
        break;
      default:
        color = 'grey700';
    }

    return color;
  };

  return (
    <>
      <Label
        fontSize={isMobile ? '12' : '32'}
        semibold
        textAlign="center"
        testId="results_section_title_text"
        id="results_section_title_text"
      >
        {t('Results')}
      </Label>
      <Banner
        margin={false}
        idDocument="results_document_type_description_text"
      />
      <CardResults
        title={t('ONBOARDING RESULT') as string}
        status={operationFinishedState.status}
        icon={onboardingIconNew(operationFinishedState.status)}
        testId="onboarding-result"
        idTitle="onboarding_card_result_title"
      >
        <CardResultsContent
          flexDirection="column"
          alignItems={isMobile ? 'start' : 'center'}
          rowGap="0.4"
        >
          <Label
            fontSize="21"
            semibold
            upperCase
            color={
              getLabelColor(
                operationFinishedState.status
              ) as InphiniteThemeColors
            }
            id="onboarding_card_result_text"
            testId="onboarding_card_result_text"
          >
            {t(
              operationFinishedState.loading
                ? 'Onboarding in progress'
                : isCanada &&
                  (operationFinishedState.status === StatusTypeList.PENDENT ||
                    operationFinishedState.status ===
                      StatusOperations.CONNECTION_ERROR ||
                    operationFinishedState.status === StatusOperations.EXPIRED)
                ? 'VALIDATION_CHECK_PLATFORM'
                : operationFinishedState.status || ''
            )}
          </Label>

          {operationFinishedState.status !== StatusTypeList.SUCCEEDED &&
            operationFinishedState.status !== StatusTypeList.DENIED && (
              <Label
                fontSize="12"
                id="onboarding_card_result_alert_text"
                testId="onboarding_card_result_alert_text"
              >
                {t(
                  operationFinishedState.loading
                    ? 'We are analyzing the information'
                    : `${operationFinishedState.status}-description`
                )}
              </Label>
            )}
        </CardResultsContent>
      </CardResults>
    </>
  );
};
